import { getRequestedListApi, raiseNotificationApi } from 'Constants';
import { Context } from 'Context/Context';
import React, { useContext, useEffect, useState } from 'react'
import Associates from './Associates';
import ProfilePicWithDetails from 'Components/Client/Cases/CaseDetails/ProfilePicWithDetails';
import ProfesssionalDetailsPopUp from 'Modals/ProfesssionalDetailsPopUp';
import { ToastContainer, toast } from 'react-toastify';
import CompleteAssistantProfile from 'Modals/CompleteAssistantProfile';
import { useNavigate } from 'react-router-dom';


function AssociatesReq() {
    const {userDetails, makeApiCallFunc} = useContext(Context);
    const navigate = useNavigate();
    const [requests, setRequests] = useState([]);
    const [approved, setApproved] = useState([]);
    const [singleUser, setSingleUser] = useState(null);
    const [sentReq, setSentReq] = useState(false);
    const [showModal, setShowModal] = useState(false);


    const profData = {
        "First name" : "firstName",
        "Last name" : "lastName",
        "Email" : "email",
        "Designation" : "legalType",
        "Firm Name" : "company",
        "Phone number" : "phoneNumber",
        "Experience" : "experience",
        "Law Firm URL" : "lawFirmLink",
        "LinkedIn" : "linkedin"  
    }

    useEffect(() => {
        makeApiCallFunc(getRequestedListApi,
            null,
            ({data}) => {
                setApproved(data.approved);
                setRequests(data.requests);
            },
            (data) => console.log(data) 
        )
    },[sentReq])

   const sendReminder = (id) => {
    const notificationObj = {
        title : "Reminder - Assistant's request to represent you " + userDetails?.firstName + " " + userDetails?.lastName,
        is_read : false,
        sender: userDetails._id,
        type: "1",
        receiver:  id,
        notificationCategory: 0,
        content: "Assistant professional "+userDetails?.firstName+" "+userDetails?.lastName+" has requested to represent you to handle your cases",
        }
    makeApiCallFunc(raiseNotificationApi, 
        notificationObj, 
            (data) => 
                {
                    console.log(data)
                    toast.success("Reminder sent successfully")
                },
            (error) => console.log(error)
        )
    }
  return (
    <>
    {
        userDetails.isUserAssistant && userDetails.profilePic ? 
        <>{
            showModal &&
            <>
            <ProfesssionalDetailsPopUp uploadNew={showModal} onClose={() => setShowModal(false)} singleUser={singleUser} profData= {profData}/>
            </>
        }
        <div className='w-full lg:px-60 px-2 my-4 lg:mt-20'>
    
            <div className='w-full'>
            {
                approved.length > 0 &&
            <>
            <div className='text-sm font-bold underline text-green-600 mb-4'>Approved access</div>
                {
                    approved?.map((item, key) => {
                        return ( 
                            item?.userId &&
                        <div className='w-full flex border text-sm justify-between cursor-pointer px-4 py-4 items-center  bg-green-50 hover:bg-green-100 mb-4 rounded shadow-md'
                        onClick={() => {setSingleUser(item?.userId); setShowModal(true)}}
                        >
                            <div className='w-12 flex justify-left text-left'> <img src = {item?.userId?.profilePic}/> </div>
                            <div className='w-10 lg:flex hidden  justify-left'> {item?.userId?.firstName} </div>
                            <div className='w-10 hidden lg:flex justify-left'> {item?.userId?.lastName}</div>
                            <div className='w-max hidden lg:flex justify-left'> {item?.userId?.email} </div>
                            <div className='w-max  font-bold bg-white rounded p-2 border text-sm text-sky-600'
                            onClick={() => navigate("/attorney/casesFeed/availableCases")}
                            > {item?.userId?.firstName} {item?.userId?.lastName}'s Dashboard</div>
                            <div className='w-max  underline text-xs text-sky-600'>Full details</div>

                        </div>)
                    })
                }
                </>
            }
            {
                requests.length > 0 &&
                <>
                <div className='text-sm font-bold underline text-sky-600 mb-4 mt-10'>Requests sent</div>
                {
                    requests?.map((item, key) => {
                        return ( 
                        <div className='w-full flex border justify-between cursor-pointer px-4 py-1 text-sm items-center  bg-sky-50 hover:bg-sky-100 mb-4 rounded shadow-md '
                        
                        >
                            <div className='w-12 '> <img src = {item?.userId?.profilePic}/> </div>
                            <div className='hidden lg:flex w-10'> {item?.userId?.firstName}</div>
                            <div className='hidden lg:flex w-10'> {item?.userId?.lastName} </div>
                            <div className='w-max hidden lg:flex'> {item?.userId?.email} </div>
                            {console.log(item.userId)}
                            <div className='w-max  underline text-xs text-sky-600'
                            onClick={() => {setSingleUser(item?.userId); setShowModal(true)}}
                            >Full details</div>
    
                            <div className='text-green-600 underline rounded p-2 px-2 text-xs w-max font-bold'
                            onClick={() => sendReminder(item?.userId?._id)}
                            >Send Reminder</div>
                        </div>)
                    })
                }
                </>
            }
            </div>
            <div className='w-full flex justify-center flex-col mt-10 border bg-gray-50 shadow-md p-4'>
                <div className='text-sm font-bold underline text-gray-600 mb-4'>Make a new Request</div>
                <Associates setSentReq={setSentReq} profData={profData}/>
            </div>
        </div>
        </>
    :
    <div>
        <CompleteAssistantProfile uploadNew={true} onClose={() => {}}/>
    </div>
    }
    
    </>
  )
}

export default AssociatesReq